const domains = [
  'kia.com',
  'landrinsbil.se',
  'www.bjorkmansbil.se',
  'www.smalandskabil.se',
  'svenskamotor.se',
  'moramotorcenter.se',
  'prod2admin-eu.kia.com',
  '127.0.0.1:3334',
  'www.bilkompaniet.com',
];

const locationIsKia = () => {
  if (typeof window === 'undefined') return false;

  const host = window.location.host.replace(/^www\./, '');

  return domains.some((domain) => domain.replace(/^www\./, '') === host);
};

const getUniqId = () => Math.random().toString(36).substring(2, 8);

const getAdminUrl = () => {
  return locationIsKia()
    ? 'https://kia.live.afonso.se'
    : (process.env.ADMIN ?? 'https://kia.dev.afonso.se');
};

const getApiToken = () => {
  return locationIsKia()
    ? '3|EDPCQxV8mfDffJ02N9uLzAH3S6IjLap5f3ItxRZB99d561de'
    : (process.env.TOKEN ??
        '4|RqQZzqaTK55e8oXVBD4iZ3CcRgRgdxbwSbz0ZwmI01141b46');
};

const formatNumber = (number: number | undefined) => {
  if (!number || number === 0) return '-';
  return new Intl.NumberFormat('sv-SE').format(number);
};

const getCookie = (name: string): string | null => {
  const cookieArr = document.cookie.split(';');

  for (let i = 0; i < cookieArr.length; i++) {
    const cookiePair = cookieArr[i].trim().split('=');

    if (cookiePair[0] === name) {
      return decodeURIComponent(cookiePair[1]); // Decode cookie value
    }
  }

  return null;
};

const setCookie = ({
  name,
  value,
  expiry,
}: {
  name: string;
  value: string;
  expiry: number;
}) => {
  const date = new Date();
  date.setTime(date.getTime() + expiry * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${encodeURIComponent(value)};${expires};path=/`; // Encode value
};

const validEmail = (email: string) => {
  const re = /\S+@\S+\.\S+/;
  return re.test(email);
};

export {
  formatNumber,
  getAdminUrl,
  getApiToken,
  getCookie,
  getUniqId,
  locationIsKia,
  setCookie,
  validEmail,
};

export const fNumber = (num: number | null | undefined): string => {
  if (num === null || num === undefined || num < 0) {
    return '-';
  }
  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: 'SEK',
    maximumFractionDigits: 0,
  };
  return num.toLocaleString('sv-SE', options);
};

export const getContainerClass = (width: string) => {
  if (!width) return '';
  return width && width === 'lg'
    ? 'kia-w-lg'
    : width && width === 'md'
      ? 'kia-w-md'
      : width && width === 'sm'
        ? 'kia-w-sm'
        : width && width === 'full'
          ? 'w-full'
          : 'kia-w-xs';
};

export const getYoutubeId = (url: string) => {
  if (!url) return null;

  const regExp =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|shorts\/)([^#\&\?]*).*/;
  const match = url.match(regExp);

  return match && match[2].length === 11 ? match[2] : null;
};
